import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "../../lib/cx.js";
export function Stack({ gap = 4, className, children, ...rest }) {
    return (_jsx("div", { className: cx("evolua-stack", `evolua-stack--${gap}`, className), ...rest, children: children }));
}
export function Inline({ gap = 3, align = "center", justify = "start", className, children, ...rest }) {
    return (_jsx("div", { className: cx("evolua-inline", `evolua-inline--${gap}`, `evolua-inline--a-${align}`, `evolua-inline--j-${justify}`, className), ...rest, children: children }));
}
export function Grid({ gap = 4, min = "14rem", columns, className, style, children, ...rest }) {
    return (_jsx("div", { className: cx("evolua-grid", `evolua-grid--${gap}`, className), style: {
            gridTemplateColumns: columns
                ? `repeat(auto-fit, minmax(min(100%, max(${min}, calc(100% / ${columns}))), 1fr))`
                : `repeat(auto-fit, minmax(min(100%, ${min}), 1fr))`,
            ...style,
        }, ...rest, children: children }));
}
export function Divider({ className, ...rest }) {
    return _jsx("hr", { className: cx("evolua-divider", className), ...rest });
}
export function VisuallyHidden({ children }) {
    return _jsx("span", { className: "evolua-vh", children: children });
}
//# sourceMappingURL=Stack.js.map